import type { TCustomerData } from 'shared/types/TCustomerService';

import type { TCreditFormEntityReducer } from '../../types';

import { mapBaseDataToCreditForm } from './mapBaseDataToCreditForm';

export const mapCustomerToCreditForm = (state: TCreditFormEntityReducer, data: Partial<TCustomerData>) => {
  return mapBaseDataToCreditForm(state, data, {
    periodSourceValue: data.period,
    userAgreement: Boolean(data.userAgreement),
    advertisingAgreement: Boolean(data.advertisingAgreement),
    registrationAddressFlat: data.registrationAddressFlat || '',
    residenceAddressFlat: data.residenceAddressFlat || '',
    residenceAddressIsRegistration: Boolean(data.residenceAddressIsRegistration),
    okved: data.okved || '',
  });
};
